import { useTranslation } from 'next-i18next';

import { Box, Button, HStack, Skeleton, SkeletonText, Text } from '@chakra-ui/react';

import { SKELETON_PROPS } from '@app/consts';

import { ApartmentSkeletonProps } from './apartment-skeleton.props';

export const ApartmentSkeleton = ({
    bodyLineCount = 3,
    withMoreDetails = false,
    hideTitle = false,
    isBestOffer = false,
}: ApartmentSkeletonProps) => {
    const { t } = useTranslation('accommodation');
    const skeletonTextProps = SKELETON_PROPS.text;

    return (
        <Box>
            {isBestOffer ? (
                <Text
                    as="h4"
                    fontWeight={'bold'}
                    textTransform={'uppercase'}
                    color={'green.solid'}
                    fontSize={'sm'}
                >
                    {t('bestOffer')}
                </Text>
            ) : null}
            {withMoreDetails ? (
                <HStack align={'flex-start'} justify={'space-between'} gap={4}>
                    <Box width={150}>
                        <Skeleton w={'100%'} height={'100px'} mb={4} />
                    </Box>
                    <Box flex={1}>
                        <SkeletonText lineClamp={5} mb={3} w={'100%'} {...skeletonTextProps} />
                    </Box>
                </HStack>
            ) : !hideTitle ? (
                <SkeletonText lineClamp={2} mb={5} w={'100%'} {...skeletonTextProps} />
            ) : null}
            <HStack mb={3} alignItems={'flex-end'} justifyContent={'space-between'}>
                <Box width={'40%'}>
                    <SkeletonText lineClamp={bodyLineCount} w={'100%'} {...skeletonTextProps} />
                </Box>
                <Box width={'40%'} maxW={'90px'}>
                    <SkeletonText
                        lineClamp={2}
                        display={'flex'}
                        alignItems={'flex-end'}
                        flexDirection={'column'}
                        {...skeletonTextProps}
                    />
                </Box>
            </HStack>
            <Skeleton>
                <Button w={'100%'} />
            </Skeleton>
        </Box>
    );
};
